import { createStore, select, setProp, withProps } from '@ngneat/elf';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

export interface DataFieldsProps {
  otc: boolean | null;
  btm: boolean | null;
  tender: boolean | null;
}

const initialProps: DataFieldsProps = {
  otc: false,
  btm: false,
  tender: false,
};

const STORE_NAME = 'sandoz-v2-data-fields';

@Injectable({ providedIn: 'root' })
export class DataFieldsRepository {
  private readonly store;

  public readonly otc$: Observable<boolean | null>;
  public readonly btm$: Observable<boolean | null>;
  public readonly tender$: Observable<boolean | null>;

  constructor() {
    this.store = createStore(
      { name: STORE_NAME },
      withProps<DataFieldsProps>(initialProps),
    );

    this.otc$ = this.store.pipe(
      select(state => state.otc),
      shareReplay({ refCount: true, bufferSize: 1 }),
    );

    this.btm$ = this.store.pipe(
      select(state => state.btm),
      shareReplay({ refCount: true, bufferSize: 1 }),
    );

    this.tender$ = this.store.pipe(
      select(state => state.tender),
      shareReplay({ refCount: true, bufferSize: 1 }),
    );
  }

  resetStore(): void {
    this.store.reset();
  }

  getState(): DataFieldsProps {
    return this.store.getValue();
  }

  setOTC(otc: DataFieldsProps['otc']): void {
    this.store.update(setProp('otc', otc));
  }

  setBTM(btm: DataFieldsProps['btm']): void {
    this.store.update(setProp('btm', btm));
  }

  setTender(tender: DataFieldsProps['tender']): void {
    this.store.update(setProp('tender', tender));
  }
}
